import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../_services/toast.service';
import { UserService } from '../_services/user.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private userService: UserService,
    private toastService: ToastService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 403) {
          // auto logout if 403 response returned from api
          // this.userService.logout();
          // location.reload();
        } else if (err.status === 401) {
          // this.userService.logout();
          // this.router.navigate(['/login']);
        } else if (err.status === 500) {
          if (request.url.indexOf('api/v2/interactions') == -1) {
            this.toastService.showDanger(
              'Ocorreu um erro. Por favor, tente novamente ou contate o administrador do seu sistema.'
            );
          }
        }
        // else if (err.status === 404){
        //     this.router.navigate(['/']);
        // }

        return throwError(err);
      })
    );
  }
}
